// Общие части передачи входа Google → установленное приложение на iPhone
// (миграция 20260925160000_pwa_login_handoffs.sql). Работает и в браузере,
// и на сервере: хэш через Web Crypto.

export const HANDOFF_TTL_MS = 10 * 60 * 1000

// 32 случайных байта в base64url — 43 символа.
const TOKEN_RE = /^[A-Za-z0-9_-]{43}$/

export function isHandoffToken(value: unknown): value is string {
  return typeof value === 'string' && TOKEN_RE.test(value)
}

function toBase64Url(bytes: Uint8Array): string {
  let s = ''
  bytes.forEach((b) => (s += String.fromCharCode(b)))
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function newHandoffSecret(): string {
  return toBase64Url(crypto.getRandomValues(new Uint8Array(32)))
}

export async function handoffId(secret: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(secret))
  return toBase64Url(new Uint8Array(digest))
}
